const formatEmployees = value => {
  if (!value) {
    return ''
  }
  const year = new Date().getFullYear()
  return `${value} (${year})`
}

const formatFundDate = (year, month) => {
  let date = year
  if (month) {
    date += `-${month}`
  }
  return date
}

const getFundYear = fundDate => {
  if (fundDate) {
    return fundDate.split('-')[0]
  }
  return ''
}

const getFundMonth = fundDate => {
  if (fundDate) {
    return fundDate.split('-')[1] || ''
  }
  return ''
}

const normalizeDataForForm = data => {
  const normalizedData = { ...data }
  const fundDate = _.get(data, 'interest.fundDate')
  if (normalizedData.interest) {
    normalizedData.interest.fundMonth = getFundMonth(fundDate)
    normalizedData.interest.fundYear = getFundYear(fundDate)
  }
  return normalizedData
}

const removeSpecialCharacters = str => {
  const stringWithNoSpecialCharacters = str.replace(/[^0-9A-Z-a-z\!\-\_\.\'\(\)]/gi, '')
  return stringWithNoSpecialCharacters.replace(/\s{2, }/gi, ' ')
}

export default {
  formatEmployees,
  formatFundDate,
  normalizeDataForForm,
  removeSpecialCharacters,
}
